import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        course: '=',
        departments: '=',
        roles: '=',
        levels: '=',
        canManageCourse: '='
    },
    template: `
        <courses-courses-steps-target
            course="vm.course"
            context="vm.context"
            departments="vm.departments"
            roles="vm.roles"
            levels="vm.levels"
            can-manage-course="vm.canManageCourse"
        />`
})

export default class {
    constructor () {
        this.context = 'add';
    }
}



// WEBPACK FOOTER //
// ./src/app/components/courses/courses/add/target/index.js